module.exports = __webpack_public_path__ + "img/home.d76d7207.png";